module.exports = __webpack_public_path__ + "static/media/notification.c5914355.svg";